<template>
  <v-overlay :model-value="true" :scrim="scrim" :opacity="0.9" class="align-center justify-center text-center">
    <v-progress-circular indeterminate></v-progress-circular>
    <p v-if="message" class="mt-5">{{ message }}</p>
  </v-overlay>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  props: {
    message: {
      type: String,
      default: null
    },
    scrim: {
      type: String,
      default: 'primary'
    }
  }
}
</script>
